let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ls6yt")).then(() => parcelRequire('aXBLi'));